export default "__VITE_ASSET__1c0febac__"